import Loader from '../../../components/Loader';
import NoData from '../../../components/NoData';
import PageHeader from '../../../components/PageHeader';
import Sidebar from '../../../components/Sidebar';
import Transitions from '../../../components/Transition';
import Filters from './components/Filters';
import ListHeader from './components/header';
import List from './components/list';
import PeriodFilter from './components/PeriodFilter';
import useActivitiesRatings from './useActivitiesRatings';

export default function ActivitiesRatings() {
  const {
    isLoading,
    fullRatings,
    doesListApiHasError,
    filteredRatings,
    handleTryAgain,
    pagesQuantity,
    currentPage,
    activitiesList,
    selectedActivity,
    handleActivityChange,
    teacherRateOptions,
    selectedTeacherRate,
    handleTeacherRateChange,
    contentRateOptions,
    selectedContentRate,
    handleContentRateChange,
    durationRateOptions,
    selectedDurationRate,
    handleDurationRateChange,
    selectedPeriod,
    handlePeriodChange,
    handleClearPeriod,
    handlePageChange,
    ratingsSplited,
  } = useActivitiesRatings();

  const hasRatings = fullRatings?.length !== 0 && !!fullRatings && !isLoading;
  const anyResultsByFilterSelection = !filteredRatings && !isLoading;
  const isListEmpty = !doesListApiHasError && (!isLoading && fullRatings.length === 0);

  return (
    <>
      <Sidebar active="Activities" />
      <Transitions>
        <Loader isLoading={isLoading} />
        <PageHeader title="Avaliações das Atividades" link="/activities" />

        {hasRatings && (
          <>
            <Filters
              activitiesList={activitiesList}
              selectedActivity={selectedActivity}
              teacherRateOptions={teacherRateOptions}
              selectedTeacherRate={selectedTeacherRate}
              contentRateOptions={contentRateOptions}
              selectedContentRate={selectedContentRate}
              durationRateOptions={durationRateOptions}
              selectedDurationRate={selectedDurationRate}
              handleActivityChange={handleActivityChange}
              handleTeacherRateChange={handleTeacherRateChange}
              handleContentRateChange={handleContentRateChange}
              handleDurationRateChange={handleDurationRateChange}
            />
            <PeriodFilter
              selectedPeriod={selectedPeriod}
              onPeriodChange={handlePeriodChange}
              onClearPeriod={handleClearPeriod}
            />
          </>
        )}

        <ListHeader
          doesListExists={hasRatings}
          hasError={doesListApiHasError}
          singularLabel="avaliação"
          pluralLabel="avaliações"
          onPageChange={handlePageChange}
          pagesQuantity={pagesQuantity}
          currentPage={currentPage}
          ratingsSplited={ratingsSplited}
        />

        {hasRatings && <List filteredList={filteredRatings} />}

        {doesListApiHasError && (
          <NoData
            icon="sad"
            label={(
              <>
                Ocorreu um erro ao obter as avaliações.
                <button type="button" onClick={handleTryAgain}>
                  Tentar Novamente
                </button>
                .
              </>
            )}
          />
        )}

        {anyResultsByFilterSelection && (
          <NoData
            icon="searchNotFound"
            label={(
              <>
                Não encontramos nenhum resultado conforme os filtros selecionados.
                Por favor, tente alterar os critérios.
              </>
            )}
          />
        )}

        {isListEmpty && !isLoading && (
          <NoData
            icon="emptyBox"
            label={(
              <>
                Não há nenhuma avaliação cadastrada
              </>
            )}
          />
        )}
      </Transitions>
    </>
  );
}
